class FilteredPosts {
  constructor(filter) {
    this.el = filter;
    this.postCards = document.querySelectorAll('.post-card');
    this.noResults = document.querySelector('.no-results');
    this.init();
    this.bindListeners();
  }

  filterCards(selectedYear) {
    let matches = 0;
    this.postCards.forEach((card) => {
      const cardYear = card.getAttribute('data-year');
      if (cardYear === selectedYear || selectedYear === "") {
        card.classList.remove('hidden');
        matches++;
      } else {
        card.classList.add('hidden');
      }
    });
    if (matches === 0) {
      this.noResults.classList.remove('hidden');
    }else {
      this.noResults.classList.add('hidden');
    }
  }

  init() {
    const initialYear = this.el.value;
    this.filterCards(initialYear);
  }

  bindListeners() {
    this.el.addEventListener('change', (event) => {
      const selectedYear = event.target.value;
      this.filterCards(selectedYear);
    });
  }
}

const filter = document.getElementById('year-filter');
if (filter) {
  new FilteredPosts(filter);
}